import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EsriExpand, EsriLocalBasemapsSource, EsriReactiveUtils } from '../../../config/esri.module';
import { BaseMapListService } from '../../../shared/service/base-map-list.service';
import { MainMapService } from '../../../shared/service/main-map.service';
import { MessageService } from '../../../core/service/message.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseWidget } from '../base-widget/base-widget';
import { ArcgisBasemapSwitchElement } from './arcgis-basemap-switch-element.interface';
import '@arcgis/map-components/components/arcgis-basemap-gallery';

@Component({
  selector: 'base-map-switch',
  templateUrl: 'base-map-switch.component.html',
  standalone: false,
})
export class BaseMapSwitchComponent extends BaseWidget implements OnInit, AfterViewInit {
  @ViewChild('baseMapSwitchComponentRef', { static: true }) baseMapSwitchComponentRef: ElementRef;
  @ViewChild('baseMapRef', { static: true }) baseMapRef: ElementRef<ArcgisBasemapSwitchElement>;

  private esriBaseMapGallery: ArcgisBasemapSwitchElement;

  constructor(
    public mainMapService: MainMapService,
    public widgetNotifyService: WidgetNotifyService,
    private _baseMapListService: BaseMapListService,
    private _messageService: MessageService,
    private translate: TranslateService
  ) {
    super(mainMapService, widgetNotifyService);
  }

  ngOnInit() {
    // Get Map View
    const mapView: __esri.MapView = this.mainMapService.mapView;
    // Get list of Basemaps
    const baseMaps = this._baseMapListService.baseMapList;

    if (baseMaps.length > 1) {
      this.createBaseMapGallery(mapView, baseMaps);

      // Create an ESRI Expand Widget
      this.createExpandProperties(mapView);
      // translate tooltip icon
      this.translateToolTipWidgetIcon(this.expandWidget, this.translate, 'WIDGET.BASEMAP_SWITCH.TOOLTIP');
      this.initWidgetListeners();
      // add widget to the main map
      mapView.ui.add(this.expandWidget, 'top-right');
    } else {
      this._messageService.warning('NOTIFICATIONS.WARNING.BASEMAP_EXPAND_WIDGET_DISABLED');
    }
  }

  ngAfterViewInit() {
    // listen on language change
    this.translate.onLangChange.subscribe(() => {
      this.translateToolTipWidgetIcon(this.expandWidget, this.translate, 'WIDGET.BASEMAP_SWITCH.TOOLTIP');
    });
  }

  private createBaseMapGallery(mapView: __esri.MapView, baseMaps: __esri.Basemap[]) {
    this.esriBaseMapGallery = this.baseMapRef.nativeElement;
    // create basemap source
    const source = new EsriLocalBasemapsSource({
      basemaps: baseMaps,
    });

    this.esriBaseMapGallery.view = mapView;
    this.esriBaseMapGallery.source = source;
    this.esriBaseMapGallery.activeBasemap = this.mainMapService.selectedBaseMap
      ? this.mainMapService.selectedBaseMap
      : source.basemaps.find(f => f['defaultBaseMap'] === true);
  }

  private createExpandProperties(mapView: __esri.MapView) {
    const expandProperties: __esri.ExpandProperties = {
      view: mapView,
      id: 'BaseMapSwitchComponent',
      content: this.baseMapSwitchComponentRef.nativeElement,
      expandIcon: 'basemap',
    };
    this.expandWidget = new EsriExpand(expandProperties);
  }

  public initWidgetListeners() {
    super.initWidgetListeners();
    // save selected basemap in mainmapservice
    EsriReactiveUtils.watch(
      () => this.esriBaseMapGallery?.activeBasemap,
      newSelectedBaseMap => {
        this.mainMapService.selectedBaseMap = newSelectedBaseMap;
      }
    );
  }
}
